import { render, staticRenderFns } from "./cooperation-type.vue?vue&type=template&id=4a1052c6&scoped=true&"
import script from "./cooperation-type.vue?vue&type=script&lang=js&"
export * from "./cooperation-type.vue?vue&type=script&lang=js&"
import style0 from "./cooperation-type.vue?vue&type=style&index=0&id=4a1052c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1052c6",
  null
  
)

export default component.exports